import styled from '@emotion/styled';
import { Button } from 'components/Buttons/Button';
import MBDialog from 'components/Elements/MBDialog';
import { theme } from 'theme';

export const DialogInnerWrapper = styled.div`
  width: 100%;
`;

export const Dialog = styled(MBDialog)`
  z-index: 20 !important;
  & .MuiDialogContent-root {
    padding: 0 !important;
    margin-bottom: 0;
    overflow: visible;
  }
  & #close_modal_button {
    right: 12px;
    top: 12px;
    z-index: 30;
  }
  & > .MuiPaper-root {
    padding: 2em !important;
  }
`;

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 21;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  #miniPDPMainContainer {
    position: relative;
    overflow: hidden;
  }
`;

export const MiniPdpColumnsWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: stretch;
`;

export const InfoOuterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
  position: relative;
`;

export const LearnMoreButton = styled(Button)`
  &:hover,
  &:focus,
  &:active {
    color: #fff;
    background: ${theme.palette.primary.main};
    box-shadow: none;
  }
`;

export const ConfigBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .MuiInput-root,
  .MuiOutlinedInput-root,
  .MuiFilledInput-root {
    height: 40px;
    max-width: 140px;
    div[role='button'] > .MuiListItemIcon-root {
      display: none;
    }
    & > span[font-size] {
      position: absolute;
      right: 0;
      top: 0;
    }
    fieldset {
      border: 0 !important;
    }
  }
  .MuiInputBase-root {
    .MuiSelect-select {
      padding: 4px 24px 4px 8px !important;
    }
  }
  .MuiSelect-icon.MuiSelect-icon.MuiSelect-icon {
    right: 0;
    top: 10px;
    width: 1.3em;
    color: ${theme.palette.grey.A400};
  }
  .selectLabel {
    color: ${theme.palette.grey.A400} !important;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
`;
